<template>
	<div id="mybutton" ref="aa">
		<el-button v-if="type==undefined||type==''?true:false" :disabled="disabled" type="primary">{{label}}</el-button>
		<el-button v-if="type=='first'?true:false"  class="first" :disabled="disabled" type="primary">{{label}}</el-button>
	</div>
</template>

<script>
	export default{
		data(){
			return{};
		},
		props:['label','disabled','type','size'],
		methods:{
		},
		mounted(){
			console.log("这个组件",this.type)
		}
	}
</script>

<style>
#mybutton{
	display: inline-block;
}
.first{
	color:#FFFFFF;
	background-color: #ADFF2F;
	border-color: #FFFFFF;
}
.el-button--primary:focus[class~='first'], .el-button--primary:hover[class~='first'] {
	opacity: 0.7;
	color:#FFFFFF;
	background-color: #ADFF2F;
	border-color: #FFFFFF;
}
/*disable状态下的显示*/
 .el-button--primary.is-disabled[class~='first'] {
	opacity: 0.5;
	color:#FFFFFF;
	background-color: #ADFF2F;
	border-color: #FFFFFF;
}
/*disable状态下的悬浮显示*/
 .el-button--primary.is-disabled:hover[class~='first'] {
	opacity: 0.5;
	color:#FFFFFF;
	background-color: #ADFF2F;
	border-color: #FFFFFF;
	border:2px solid red;
}

</style>


// WEBPACK FOOTER //
// src/components/template/mybutton.vue